<template>
  <div class="full-container service" v-if="show">
    <!-- <div class="banner">
        <el-image :src="banner"></el-image>
        </div> -->
    <apj-page-banner :options="options"></apj-page-banner>
    <div class="container" style="padding-bottom: 40px">
      <div
        class="industry"
        v-for="(item, index) in industry"
        :key="index"
        :ref="`row_${index}`"
      >
        <div class="cover">
          <el-image :src="item.cover" fit="cover"></el-image>
          <div class="info" style="text-shadow: 0px 1px 15px rgba(0,0,0,0.7);">
            <div class="title">{{ item.name }}</div>
            <div class="text pi-fw-700" style="max-width: 470px">
              {{ item.desc }}
            </div>
          </div>
        </div>
        <div
          class="subs"
          :class="
            isMobile || show_obj[`row_${index}`]
              ? 'animate__animated animate__fadeInUp'
              : 'hide'
          "
        >
          <div class="sub" v-for="(sub, sindex) in item.sub" :key="sindex">
            <div class="header">
              <div class="split"></div>
              <span class="title">{{ sub.name }}</span>
            </div>
            <div class="body">
              <div
                class="wrapper"
                v-for="(prod, pindex) in sub.sub"
                :key="pindex"
              >
                <router-link :to="prod.link">
                  <div class="prod">
                    <i class="iconfont" :class="prod.icon"></i>
                    <span>{{ prod.name }}</span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <apj-page-contact></apj-page-contact> -->
  </div>
</template>

<script>
import { isMobile, scrollTop } from "@/utils";
import ApjPageContact from "@/components/apj-page-contact";
import ApjPageBanner from "@/components/apj-page-banner";
export default {
  name: "product",
  components: {
    ApjPageContact,
    ApjPageBanner,
  },
  data() {
    return {
      isMobile: isMobile(),
      offsetTop: {
        row_0: 0,
        row_1: 0,
        row_2: 0,
      },
      show_obj: {
        row_0: false,
        row_1: false,
        row_2: false,
      },
      options: {
        banner: require("@/assets/images/banner/product.png"),
        title: "行业方案与产品厚积薄发，助力企业数字化转型创新",
        // text: "助力客户业务价值落地，全面提升行业竞争力",
        text: "",
      },
      industry: [
        {
          name: "数字工厂",
          cover: require("@/assets/images/product/digitalized_factory_bg.png"),
          desc:
            "建立用户和合作伙伴共建智能制造系统的生态环境，以企业价值增值为核心，打造企业智慧研发、智慧管理、智能生产、智能服务和智能决策系列解决方案。",
          sub: [
            {
              name: "企业生产智能化解决方案",
              sub: [
                {
                  name: "企业进销存管理系统（PSI）",
                  icon: "iconjinxiaocun",
                  link: "/product/newManagement",
                },
                {
                  name: "标准仓储管理系统（WMS）",
                  icon: "iconcangchuguanli",
                  link: "/product/newManagement",
                },
                {
                  name: "制造执行管理系统（MES）",
                  icon: "iconzhizaozhihang",
                  link: "/product/newManagement",
                },
                {
                  name: "企业供应链管理系统（SCM）",
                  icon: "icongongyinglian",
                  link: "/product/newManagement",
                },
              ],
            },
            {
              name: "纺织智能制造解决方案",
              sub: [
                {
                  name: "生产管理中央控制系统（CCS）",
                  icon: "iconshengchanguanli",
                  link: "/product/spinning",
                },
                {
                  name: "车间管理生产监控管理平台（SFTS）",
                  icon: "iconshengchanjiankong",
                  link: "/product/spinning",
                },
                {
                  name: "企业信息门户（EIP）",
                  icon: "iconqiyemenhu",
                  link: "/product/spinning",
                },
                {
                  name: "质量检测QI验布管理系统（Q1）",
                  icon: "iconzhiliangjiance",
                  link: "/product/spinning",
                },
              ],
            },
            {
              name: "能源管理系统解决方案",
              sub: [
                {
                  name: "陕鼓能源数据管理平台",
                  icon: "iconnengyuanguanli",
                  link: "/product/resourceManagement",
                },
                {
                  name: "智慧燃气管理系统",
                  icon: "iconranqi",
                  link: "/product/fuelgas",
                },
              ],
            },
          ],
        },
        {
          name: "互联网教育",
          cover: require("@/assets/images/product/network_edu_bg.png"),
          desc:
            "针对在线教育行业的应用场景，海量数据、交互形式多样的特点推出了不同垂直行业的一站式解决方案。",
          sub: [
            {
              name: "互联网+教育解决方案",
              sub: [
                {
                  name: "实训邦云课堂",
                  icon: "iconyunketang",
                  link: "/product/educloud",
                },
                {
                  name: "企业大学",
                  icon: "icondaxuemingcheng",
                  link: "",
                },
              ],
            },
          ],
        },
        {
          name: "医疗大健康",
          cover: require("@/assets/images/product/health_bg.png"),
          desc:
            '基于"医、养、健、管"的产业模式，面向健康管理全流程，精准定位医疗健康服务场景的系列解决方案。',
          sub: [
            {
              name: "智慧医疗/养老解决方案",
              sub: [
                {
                  name: "云上中医馆综合服务平台",
                  icon: "iconzhongyi",
                  link: "",
                },
                {
                  name: "智慧养老院管理系统",
                  icon: "iconyanglaoyuan",
                  link: "",
                },
                {
                  name: "鲸云诊所",
                  icon: "iconjingyun",
                  link: "",
                },
              ],
            },
          ],
        },
      ],
      productList: [
        {
          name: "能源管理平台解决方案",
          desc: "创建未来，构建以延伸服务为核心的服务线+城市轨道交通智慧生态圈",
          link: "/product/resourceManagement",
          img: require("@/assets/site/programme_resource_management.jpg"),
        },
        {
          name: "鲸云诊所 · 医疗健康解决方案",
          desc: "创建未来，构建以延伸服务为核心的服务线+城市轨道交通智慧生态圈",
          link: "创建未来，构建以延伸服务为核心的服务线+城市轨道交通智慧生态圈",
          img: require("@/assets/site/programme_jingyun.jpg"),
          isRight: true,
        },
        {
          name: "实训邦云课堂 · 在线教育解决方案",
          desc: "创建未来，构建以延伸服务为核心的服务线+城市轨道交通智慧生态圈",
          link: "/product/educloud",
          img: require("@/assets/site/programme_educloud.jpg"),
        },
        {
          name: "ATP测试机器人解决方案",
          desc: "创建未来，构建以延伸服务为核心的服务线+城市轨道交通智慧生态圈",
          link: "/product/atp",
          img: require("@/assets/site/programme_atp.jpg"),
          isRight: true,
        },
      ],
      // banner: require('@/assets/images/banner/service.jpg'),
      msg: "Welcome to Your Vue.js App",
      show: false,
    };
  },
  mounted() {
    this.show = true;
    // 进入页面时，菜单是否透明，或不显示阴影，默认为false，这里是示例
    globalEvent.$emit("changeHeaderTransparent", {
      isTransparent: true,
      isNoShadow: false,
    });
    globalEvent.$emit("changeMenu", 3);
    setTimeout(() => {
      this.loadScroll();
      this.loadTop();
      this.$nextTick(()=>{
        window.scrollTo(1, 0);
      })
    }, 1000);
  },
  destroyed() {
    this.show = false;
  },
  methods: {
    loadScroll() {
      scrollTop((res) => {
        for (const key in this.offsetTop) {
          if (!this.show_obj[key] && res.scrollH >= this.offsetTop[key]) {
            this.show_obj[key] = true;
          }
        }
      });
    },
    loadTop() {
      for (const key in this.offsetTop) {
        const client_height = document.documentElement.clientHeight;
        const height = this.$refs[key][0].offsetHeight / 2;
        this.offsetTop[key] =
          this.$refs[key][0].offsetTop - client_height + height;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/theme.scss";

div {
  width: 100%;
}

/** page style */
.title {
  font-size: 30px;
  font-weight: bold;
  line-height: 2em;
}

.text {
  line-height: 2em;
}

.industry {
  padding: 30px 0;
  &:first-child {
    padding-top: 80px;
  }

  .cover {
    position: relative;
    width: 100%;
    height: 320px;
    overflow: hidden;
    display: flex;
    align-items: center;

    .el-image {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -1;
    }

    .info {
      // width: 36%;
      max-width: 620px;
      padding: 60px;
      text-align: left;

      > div {
        color: $color-text-white;
      }
    }
  }

  .subs {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .sub {
      padding-top: 32px;

      .header {
        text-align: left;
        display: flex;
        align-items: center;

        .split {
          width: 3px;
          height: 14px;
          background-color: $color-bg-primary;
          margin-right: 8px;
        }
        .title {
          font-size: 16px;
        }
      }
      .body {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: calc(100% + 16px);
        margin-left: -8px;

        .wrapper {
          width: 25%;
          padding: 16px 8px 0 8px;

          .prod {
            display: flex;
            flex-direction: column;
            margin-top: 5px;
            border: 1px solid #e5e5e5;
            padding: 20px;
            cursor: pointer;
            height: 100%;

            .iconfont {
              color: $color-text-primary;
              font-size: 34px;
              margin-bottom: 10px;
            }

            &:hover {
              margin-top: 0px;
              border-top: 6px solid $color-border-primary;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/index.vue